<template>
  <div
    class="border-b border-black-0.1 py-4"
    :class="{
      'opacity-50': !isChecked,
    }"
  >
    <div class="flex items-center">
      <div class="p-3.5">
        <label class="block h-5 w-5 relative cursor-pointer">
          <input
            type="checkbox"
            class="custom-checkbox h-5 w-5 bg-white rounded checked:bg-yellow-brand cursor-pointer"
            v-model="isChecked"
          />
          <svg-sprite
            href="icon-tick"
            class="checkbox-tick h-4 w-4 absolute pin-c pointer-events-none"
          ></svg-sprite>
        </label>
      </div>
      <input
        type="number"
        class="h-15 w-15 text-center bg-white font-primary font-extrabold text-blue-brand text-16 uppercase tracking-1/4"
        min="0"
        :max="peopleCount"
        :disabled="!isChecked"
        :value="selectedExtra ? selectedExtra.quantity : 0"
        @input="updateExtraQuantity($event, extra.uuid)"
      />
      <div>
        <p class="font-primary font-extrabold text-blue-brand text-14 tracking-1/4 pl-2.5">
          {{ extra.name }}
        </p>
        <p class="font-primary font-normal text-blue-brand text-14 tracking-1/4 pl-2.5">
          {{ dateString }}
        </p>
      </div>
    </div>
    <div class="flex items-center justify-between pl-2.5 pr-5 pt-2.5">
      <p class="text-center font-primary font-normal text-blue-dark text-20 leading-1 pr-10">
        <display-price :price-gbp="extra.price_gbp" :price-usd="extra.price_usd"></display-price>
      </p>
      <hr class="h-0.5 w-full bg-grey-lighter" />
      <p
        class="text-center font-primary font-extrabold text-blue-dark text-20 leading-1 pl-10"
        v-if="selectedExtra"
      >
        <display-price
          :price-gbp="extra.price_gbp * selectedExtra.quantity"
          :price-usd="extra.price_usd * selectedExtra.quantity"
        ></display-price>
      </p>
    </div>
  </div>
</template>

<script>
import { formatDateRange } from '../src/Helpers.js';
import DisplayPrice from './DisplayPrice.vue';
import SvgSprite from '../vendor/enso/components/SvgSprite.vue';
import find from 'lodash/find';
import HandlesAdventures from './Mixins/HandlesAdventures';
import add from 'date-fns/add';
import formatISO from 'date-fns/formatISO';

export default {
  components: { DisplayPrice, SvgSprite },

  mixins: [HandlesAdventures],

  props: {
    extra: {
      type: Object,
      required: true,
    },
  },

  computed: {
    dateString() {
      if (this.selectedDeparture) {
        let depStart = this.selectedDeparture.start_date;
        let start = add(new Date(depStart), { days: this.extra.offset });
        let end;

        if (this.extra.duration) {
          end = add(new Date(depStart), { days: this.extra.duration - 1 + this.extra.offset });
        } else {
          end = new Date(this.selectedDeparture.end_date);
        }

        return formatDateRange(formatISO(start), formatISO(end));
      }
    },

    selectedExtras() {
      return this.$store.state.departure.extras;
    },

    selectedExtra() {
      return find(this.selectedExtras, { uuid: this.extra.uuid });
    },

    peopleCount() {
      return this.$store.state.departure.peopleCount;
    },

    isChecked: {
      get() {
        return (
          this.selectedExtras.filter((extra) => {
            return extra.uuid === this.extra.uuid;
          }).length > 0
        );
      },
      set() {
        this.toggleExtraChecked();
      },
    },
  },

  methods: {
    toggleExtraChecked() {
      this.$store.commit('departure/TOGGLE_SELECT_EXTRA', this.extra);
    },

    updateExtraQuantity(event, uuid) {
      this.$store.commit('departure/UPDATE_EXTRA_QUANTITY', {
        quantity: parseInt(event.target.value, 10),
        uuid,
      });
    },
  },
};
</script>
